import { authConstants } from "../../../constants/auth";

let token = JSON.parse(localStorage.getItem("user"));
const initialState = token
  ? { loggedIn: true, token, user: null, loading: true }
  : {};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case authConstants.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        token: payload,
      };
    case authConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        token: payload,
      };
    case authConstants.GETTING_CURRENT_USER:
      return {
        ...state,
        loggedIn: true,
        user: payload,
        loading: false,
      };
    case authConstants.LOGIN_FAILURE:
      return {};
    case authConstants.LOGOUT:
      return {};
    default:
      return state;
  }
}
